/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Filters_Reset_ButtonInputs */



/**
* | output |
* | --- |
* | "Reset All" |
*
* @param {Video_Filters_Reset_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_filters_reset_button = /** @type {((inputs?: Video_Filters_Reset_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Filters_Reset_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tout reinitialiser")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alles zurücksetzen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reimposta tutto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сбросить все")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restablecer todo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("全部重置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべてリセット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी को पुनः तैयार करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Redefinir tudo")
	return /** @type {LocalizedString} */ ("Reset All")
});